<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
html{
  width: 100%;
  height: 100%;
  background-color: #fff;
}
body{
  min-width: 1280px;
  width: 100%;
  height: 100%;
}
#app{
  width: 100%;
  height: 100%;
}
*{
  margin: 0;
  padding: 0;
  font-family: PingFangSC-Regular,\\5FAE\8F6F\96C5\9ED1,sans-serif;
  font-size: 1rem;
  outline: none;
  box-sizing: border-box;
}
::-webkit-scrollbar {
    width: 6px;
    background-color: #161d28;
}
::-webkit-scrollbar-thumb {
  height: 1px;
  border-radius: 3px;
  background-color: #222639;
}
li{
  list-style: none;
}

input:-webkit-autofill , textarea:-webkit-autofill, select:-webkit-autofill {
	-webkit-text-fill-color: #dfdfdf !important;
	-webkit-box-shadow: 0 0 0px 1000px transparent  inset !important;
    background-color:transparent;
    background-image: none;
     transition: background-color 50000s ease-in-out 0s; //背景色透明  生效时长  过渡效果  启用时延迟的时间
}

input{
  border: 0;
  outline: 0;
  border-radius: 2px;
  background: transparent;
}
input[type='number']{-moz-appearance:textfield;}
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {-webkit-appearance: none;margin: 0;}
input[type="text"]::-ms-clear{display:none;}/*隐蔽文本框叉子*/
input[type="password"]::-ms-reveal{display:none;}/*隐蔽暗码框小眼睛*/
a{
  color: #333;
  cursor: pointer;
  text-decoration: none;
}
.ov{ overflow:hidden;}
#app {
  width: 100%;
  height: 100%;
}
.el-scrollbar__wrap{
  overflow:hidden;
}

.green{
  color: #4db872;
}
.red{
  color: #ee6560;
}
.aaa{
  color:#aaa;
}
.eee{
  color:#eee;
}
.blue{
  color:#2558d9;
}
.el-slider__button{
  border-color: #4db872;
}
.el-slider__bar{
  background: #4db872;
}
.mask{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 98;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  overflow: hidden;
}
.alert-pwd-box{
    position: fixed;
    left: 50%;
    top: 50%;
    z-index: 1000;
    width: 260px;
    margin-left: -130px;
    padding: 12px 22px 34px 22px;
    background: rgba(55, 76, 124,.9);
    border-radius: 6px;
    box-sizing: border-box;
    transform: translateY(-50%);
}
.alert-pwd-box .alert-head{
    position: relative;
    padding: 0 6px;
    color: #fff;
    font-size: 14px;
    text-align: center;
}
.alert-pwd-box .close{
    position: absolute;
    right: 15px;
    top: 15px;
    width: 12px;
    height: 12px;
    cursor: pointer;
}
.alert-pwd-box .pwd-box{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 25px;
    border: 1px solid #fff;
}
.alert-pwd-box .pwd-box .pwd{
    flex: 1;
    height: 35px;
    list-style: none;
}
.alert-pwd-box .pwd-box .pwd .input{
    width: 100%;
    height: 35px;
    color: #fff;
    font-size: 20px;
    font-weight: bold;
    border-right: 1px solid #fff;
    background: #374C7C;
    text-align: center;
    border-radius: 0;
    outline: none;
    box-sizing: border-box;
}
.alert-pwd-box .pwd-box .pwd:last-child .input{
    border-right: none;
}
.nodata{
  color: #333;
  font-size: 12px;
  width: 100%;
  line-height: 40px;
  text-align: center;
}
.el-message--success{
    display: none!important;;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue